export const ProjectActionTypes = {
  PROJECT_LIST_REQUEST: 'PROJECT_LIST_REQUEST',
  PROJECT_LIST_SUCCESS: 'PROJECT_LIST_SUCCESS',
  PROJECT_LIST_FAIL: 'PROJECT_LIST_FAIL',
  SET_PROJECTS: 'SET_PROJECTS',
  REMOVE_PROJECTS: 'REMOVE_PROJECTS',
};
